"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useServiceCallCodeListAll;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _useServiceCallList = _interopRequireDefault(require("../useServiceCallList"));

/**
 * Vseobecny hook pre naladovanie ciselniku z API.
 *
 * @param {Object} [options] Nastaveni volani
 * @param {string} [options.clientCode='api'] string identifikujici pouziteho clienta. Client je definovan pomoci
 *       rodiny provideru spojeni `ConnectServer`.
 * @param {Array} [options.initialArgs] pokud !== `undefined` zavola se `action` okamzite po namontovani komponenty.
 *       V opacnem pripade se ceka na manualni zavolani akce
 * @param {'none' | 'success' | 'warning' | 'error'} [options.meaning='none'] identifikuje vyznam akce. Dle vyznamu je
 *       nastaveno napriklad podbarveni toastu.
 * @param {boolean} [options.returnOnlyAction=true] pokud je `true` vysledkem je samotna akce
 *
 * @param {string} serviceName Nazev sluzby.
 *
 * @returns {(...args) => Promise | [result, error, loading, (...args) => Promis]} Pokud je `returnOnlyAction === true`
 *   vraci samotnou akci. V opacnem pripade vraci `tuple` s:
 *     - `result` - vysledkem volani sluzby. Default `undefined`.
 *     - `error` - chyba po volani sluzby. Default `null`.
 *     - `loading` - indikator loadovani, ktery je v prubehu loadovani `true`. Default `true`
 */
function useServiceCallCodeListAll(options, serviceName) {
  return (0, _useServiceCallList.default)((0, _extends2.default)({
    returnOnlyAction: true
  }, options), serviceName);
}